// WHERE A RE-READ MAY LAND (PR #255 review, #56). A write the desk started on
// one booking can finish after Patricia has moved to another booking or
// household. The re-read that follows must touch only what is still on screen:
// the booking if it is still the selection, its household only then, and a
// household context only onto the household still open.

export function rereadPlan(now: { selectedId: string | null; ownerId: string | null }, wroteOn: string): { booking: boolean; ownerId: string | null } {
  const still = now.selectedId === wroteOn;
  return { booking: still, ownerId: still ? now.ownerId : null };
}

export function landsOnOwner(openOwnerId: string | null, loadedOwnerId: string): boolean {
  return openOwnerId === loadedOwnerId;
}
